import { useMemo } from 'react'
import { useGetRegionsQuery } from '../../api'

/**
 * Fetches all regions via the PartnersService GraphQL API and returns a lookup
 * map of region ID to region name.
 *
 * The region list is small and stable, so it's fetched once and cached by Apollo.
 */
export const useRegionNames = (): Map<string, string> => {
  const { data } = useGetRegionsQuery()

  return useMemo(() => {
    const map = new Map<string, string>()
    const regions = data?.instacart_customers_partners_v1_PartnersService_GetRegions?.regions
    if (regions) {
      for (const r of regions) {
        map.set(String(r.id), r.name ?? '')
      }
    }
    return map
  }, [data])
}
